import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReCaptcha from 'react-google-recaptcha';
import SubmitButton from './SubmitButton';

import './FeedbackForm.scss';

class FeedbackForm extends Component {

    static propTypes = {
        closeAction: PropTypes.func.isRequired,
        reCaptchaKey: PropTypes.string.isRequired,
        inFocusAction: PropTypes.func,
        formSubmitAction: PropTypes.func.isRequired,
        resetFormAction: PropTypes.func.isRequired,
        feedbackSent: PropTypes.bool.isRequired,
        sendingError: PropTypes.bool.isRequired
    }

    state = {
        feedbackType:       { value: '' },
        feedbackText:       { value: '' },
        feedbackRating:     { value: '' },
        feedbackRecaptcha:  { value: '' },
        submitDisabled:     true,
        error:              false,
        feedbackSent:       false,
    }

    componentDidMount() {
        if(this.props.feedbackSent || this.props.sendingError) {
            this.props.resetFormAction()
        }
    }

    componentDidUpdate(prevProps) {
        let stateUpdates = {};
        if (this.props.feedbackSent !== prevProps.feedbackSent) {
            stateUpdates = {...stateUpdates, submitDisabled: true, feedbackSent: true };
        }

        if (this.props.sendingError !== prevProps.sendingError) {
            stateUpdates = {...stateUpdates, error: this.props.sendingError}
        }

        if (Object.keys(stateUpdates).length) {
            this.setState(stateUpdates) //eslint-disable-line react/no-did-update-set-state
        }
    }

    isSubmitDisabled(state) {
        return Object.entries(state)
        .filter(objPair => {
            if (objPair[1].value) {
                return !objPair[1].value;
            }
            return true;
        })
        .length === 4;
    }

    handleOnChange = id => event => {
        const value = event.target.value;
        const state = {...this.state, [id]: {...this.state[id], value}};
        if (this.state[id] && value) {
            this.setState({
                [id]: {...this.state[id], value},
                submitDisabled: this.isSubmitDisabled(state)
            });
        }
    }

    handleOnBlur = () => {
        if (this.props.inFocusAction) {
            this.props.inFocusAction(false);
        }
    }

    handleOnFocus = () => {
        if (this.props.inFocusAction) {
            this.props.inFocusAction(true);
        }
    }

    handleOnSubmit = () => {
        const values = Object.entries(this.state)
        .reduce((values, objPair) => {
            if (objPair[1].value) {
                values[objPair[0]] = objPair[1].value
            }
            return values;
        }, {});
        this.props.formSubmitAction(values);
    }

    handleOnCancel = () => {
        this.props.closeAction()
    }

    handleOnCaptchaSuccess = key => {
        const state = {...this.state, feedbackRecaptcha: {value: key}};
        this.setState({
            feedbackRecaptcha: {value: key},
            submitDisabled: this.isSubmitDisabled(state)
        });
    }

    render() {
        return (
            <aside className="feedback-form-wrapper">
                <header>
                    <p>We're always looking to improve Sporting Life for our customers and we'd really like to know what you think of Sporting Life.</p>
                </header>
                <form id="feedbackForm">
                    <div className="form-group">
                        <label htmlFor="feedbackType">What would you like to tell us about today?</label>
                        <select id="feedbackType" onChange={this.handleOnChange('feedbackType')} value={this.state.feedbackType.value}>
                            <option disabled value="">-- Please select --</option>
                            <option value="Something I like">Something I like</option>
                            <option value="Something I think could be better">Something I think could be better</option>
                            <option value="I have a technical issue">I have a technical issue</option>
                            <option value="Something else">Something else</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="feedbackText">Please give your feedback:</label>
                        <textarea id="feedbackText" onChange={this.handleOnChange('feedbackText')} value={this.state.feedbackText.value}></textarea>
                    </div>
                    <div className="form-group">
                        <label htmlFor="feedbackRating">On a scale of 0-10, how would you rate Sporting Life and how likely are you to recommend us to a friend?</label>
                        <select id="feedbackRating" onChange={this.handleOnChange('feedbackRating')} value={this.state.feedbackRating.value}>
                            <option disabled value="">-- Please select --</option>
                            <option value="10">10 - Extremely likely</option>
                            <option value="9">9</option>
                            <option value="8">8</option>
                            <option value="7">7</option>
                            <option value="6">6</option>
                            <option value="5">5</option>
                            <option value="4">4</option>
                            <option value="3">3</option>
                            <option value="2">2</option>
                            <option value="1">1</option>
                            <option value="0">0 - Not at all likely</option>
                        </select>
                    </div>
                    <div className="form-captcha">
                        <ReCaptcha sitekey={this.props.reCaptchaKey} onChange={this.handleOnCaptchaSuccess}/>
                    </div>
                </form>
                <footer>
                    {this.state.error &&
                        <p className="feedback-form-error">We're sorry, but there has been an error and your feedback could not be sent. Please try again.</p>
                    }
                    {this.state.feedbackSent &&
                        <p>Thank you for your feedback.</p>
                    }
                    <button className="btn cancel-btn" onClick={this.handleOnCancel} type="button">Close</button>
                    <SubmitButton successResult={this.state.feedbackSent} btnClass="btn feedback-submit-btn" label="Submit Feedback" onClickAction={this.handleOnSubmit} disabled={this.state.submitDisabled} formRef="feedbackForm"/>
                </footer>
            </aside>
        )
    }
}

export default FeedbackForm;


// WEBPACK FOOTER //
// ./modules/Common/components/FeedbackForm.js